import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Injectable } from "@angular/core";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { CHANNEL_MARKUP } from "../IMarkupService";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { MarkupCriteria } from "../../model/core/MarkupCriteria";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TRADING_SOURCE_INTERNAL } from "shared/cubiq-services/model/TradingSource.constants";
import { MarkupPromiseService } from "./MarkupPromiseService";

@Injectable()
export class MarkupPrimaryService extends MarkupPromiseService {
  protected broker: ServiceMessageBroker;

  constructor(private worker: CubiqWorker, protected factory: ServiceMessageBrokerFactory) {
    super();

    this.broker = this.factory.createMessageBroker(CHANNEL_MARKUP, true, true);
    this.broker.registerMethod(
      "retrieveMarkupForCriteria",
      [PRIMITIVE],
      this.retrieveMarkupForCriteria.bind(this),
      CubiqTS.ENCODABLE(CubiqTS.MarkupInfoImpl),
    );
  }

  public retrieveMarkupForCriteria(
    criteria: MarkupCriteria,
  ): Promise<CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl> {
    let request: CubiqTS.CalculateMarkupRequestImpl = new CubiqTS.CalculateMarkupRequestImpl();
    request.accountCd = criteria.account;
    request.clientCd = criteria.clientCd;

    request.ccy1 = criteria.base;
    request.ccy2 = criteria.nonBase;
    request.fixedCcy = criteria.fixedCcy;
    request.clientBuysFixed = criteria.clientBuysFixed;
    request.orderType = this.requestOrderTypeToOrderType(criteria.requestOrderType);
    request.product = criteria.product;
    request.tenor = criteria.tenor ?? null;
    if (criteria.valueDate != null) {
      request.valueDate = CubiqTS.moment(
        Date.UTC(criteria.valueDate.year, criteria.valueDate.month - 1, criteria.valueDate.day),
      ).utc();
    }
    request.tradingChannel = criteria.tradingSource;

    if (request.tradingChannel == null) {
      request.tradingChannel = TRADING_SOURCE_INTERNAL;
    }

    request.benchmarkCd = criteria.benchmarkCode;
    request.requestRate =
      criteria.requestRate != null && criteria.requestRate != ""
        ? new CubiqTS.BigNumber(criteria.requestRate)
        : null;
    request.amount = new CubiqTS.BigNumber(criteria.orderAmount);

    request.benchmarkCd = criteria.benchmarkCode;
    request.algoStrategyName = criteria.algoStrategyName;
    if (criteria.benchmarkDts) request.benchmarkDts = CubiqTS.moment(criteria.benchmarkDts);

    return new Promise<CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl>((res) => {
      this.worker
        .postServiceRequest(request)
        .then((value: CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl) => {
          if (value != null) {
            res(value);
          } else {
            res(null);
          }
        });
    });
  }

  private requestOrderTypeToOrderType(
    requestOrderType: CubiqTS.RequestOrderType,
  ): CubiqTS.OrderType {
    switch (requestOrderType) {
      case CubiqTS.RequestOrderType.TP:
        return CubiqTS.OrderType.LIMIT_TP;
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        return CubiqTS.OrderType.LIMIT_SL;
      case CubiqTS.RequestOrderType.CALL:
        return CubiqTS.OrderType.LIMIT_CALL;
      case CubiqTS.RequestOrderType.ALGO:
        return CubiqTS.OrderType.ALGO;
      case CubiqTS.RequestOrderType.BMARK:
        return CubiqTS.OrderType.BENCHMARK;
      case CubiqTS.RequestOrderType.MARKET:
        return CubiqTS.OrderType.MARKET;
    }
    return null;
  }
}
